import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { KIUNGO_DOMAIN, LOGO_TCEL, LOGO_KIUNGO  } from '../../app.service';

// Services
import { SidebarService } from '../../services/sidebar.service';
import { AuthenticationService } from '../../services/authentication.service';
import {AppBase} from '../../app-base';

// Menu
declare var require: any;
const jsonMenu = require('../../../assets/menu/menu.json');

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.sass']
})
export class ToolbarComponent extends AppBase implements OnInit {

  // variables
  public administrationName: string;
  public userInSession: string;
  public menu = null;
  public search = null;
  public query = '';
  public showSearch = null;
  public currentUser = null;
  public imageUser = null;
  public imgUser = null;
  public propertySelected = null;
  public realmUser = null;
  public logoCommunity = LOGO_TCEL;

  constructor(
    private _translateService: TranslateService,
    private _sidebarService: SidebarService,
    private _route: ActivatedRoute,
    private _router: Router,
    private location: Location,
    private _authenticationService: AuthenticationService,
  ) {
    super();
    this._route.queryParams.subscribe(params => {
      if (params['realm']) {
        this.realmUser = params['realm'];
      }
    });

    // let realmUser = 'kastor';
    const angularRoute = this.location.path();
    const url = window.location.href;
    let domainAndApp = url.replace(angularRoute, '');
    domainAndApp = this._authenticationService.getDomain(domainAndApp);
    if (this.realmUser === 'kiungo' || domainAndApp === KIUNGO_DOMAIN) {
      this.logoCommunity = LOGO_KIUNGO;
    }
  }

  ngOnInit() {
    this.administrationName = localStorage.getItem('currentAdministration');
    const objectUser = JSON.parse(localStorage.getItem('currentUser'));
    this.propertySelected = JSON.parse(localStorage.getItem('propertySesion'));
    this.menu = jsonMenu.menu;
    if (this.menu) {
      const listsOfMenuItems = [];
      this.menu.forEach(element => {
        if (element.link) {
          listsOfMenuItems.push(element);
        } else {
          if (element.sub.length > 0) {
            element.sub.forEach(item => {
              if (item.sub.length > 0) {
                item.sub.forEach(ele => {
                  if (ele.sub.length > 0) {
                    ele.sub.forEach(elem => {
                      listsOfMenuItems.push(elem);
                    });
                  } else {
                    listsOfMenuItems.push(ele);
                  }
                });
              } else {
                listsOfMenuItems.push(item);
              }
            });
          }
        }
      });

      this.search = listsOfMenuItems;

      const translationList = [];

      this.search.forEach(menu => {
        translationList.push(menu.name);
      });

      this._translateService.get(translationList)
        .subscribe((translation: any) => {
          this.search.forEach(se => {
            const text = translation[se.name];
            se.text = text;
          });
        });
    }
    if (objectUser) {
      const name = objectUser.name.split(' ');
      this.userInSession = `${name[0]} ${name[1] && name[1].length > 0 ? name[1].charAt(0) : ''}.`;
      if (objectUser.user_img) {
        this.imgUser = objectUser.user_img;
      } else {
        this.imgUser = '../../../assets/img/user2.png';
      }
    }

  }

  public toggleClass(): void {
    this._sidebarService.changeStateSidebar();
  }

  public clear(): void {
    this.cleanStorage();
  }

  public clickLink(): void {
    this.query = '';
  }

  public queryTrim(): string {
    return this.query.trim();
  }

  public returnSelectProperty(): void {
    localStorage.removeItem('propertySesion');
    this._router.navigate(['/properties']);
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/toolbar/toolbar.component.ts